var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12.06,10.61H11.3L11,10.35a6.27,6.27,0,1,0-.68.68l.26.27v.76L13.54,15,15,13.54Zm-5.8,0a4.35,4.35,0,1,1,4.35-4.35h0A4.35,4.35,0,0,1,6.26,10.61Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }